import React from 'react';
import cn from 'classnames';
import css from './NYNewbieBanner.module.scss';
// @ts-ignore
import desktopFirstBlockImgPath from './NY2024Img/desktopFirstBlock.jpg';
// @ts-ignore
import desktopSecondBlockImgPath from './NY2024Img/desktopSecondBlock.jpg';
// @ts-ignore
import mobileFirstBlockImgPath from './NY2024Img/mobileFirstBlock.jpg';
import mobileSecondBlockImgPath from './NY2024Img/mobileSecondBlock.png';

export function NYNewbieBanner() {
    return (
        <div className={css.newbieBannerRoot}>
            {/* FLEX WRAPPER */}
            <div className={css.newbieBannerCardsWrapper}>
                {/* LEFT SIDE */}
                <div className={css.newbieBannerCard}>
                    <div className={cn(css.newbieBannerCardTitle, css.first)}>
                        Мы приготовили
                        <br />
                        для вас лишний час
                        <br />
                        в сутках
                    </div>
                    <div className={cn(css.newbieBannerCardImg, css.first)}>
                        <picture>
                            <source
                                media="(max-width: 1023px)"
                                type="image/png"
                                srcSet={mobileFirstBlockImgPath}
                            />
                            <source
                                media="(min-width: 1024px)"
                                type="image/png"
                                srcSet={desktopFirstBlockImgPath}
                            />
                            <img
                                className={cn(css.newbieBannerCardImgItem, css.first)}
                                alt="first-block-img"

                            />
                        </picture>
                    </div>
                </div>
                {/* RIGHT SIDE */}
                <div className={css.newbieBannerCard}>
                    <div className={cn(css.newbieBannerCardTitle, css.second)}>
                        А вы
                        <br />
                        приготовите
                        <br />
                        Оливье за 15 минут
                    </div>
                    <div className={cn(css.newbieBannerCardImg, css.second)}>
                        <picture>
                            <source
                                media="(max-width: 1023px)"
                                type="image/png"
                                srcSet={mobileSecondBlockImgPath}
                            />
                            <source
                                media="(min-width: 1024px)"
                                type="image/png"
                                srcSet={desktopSecondBlockImgPath}
                            />
                            <img
                                className={cn(css.newbieBannerCardImgItem, css.second)}
                                alt="second-block-img"
                            />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    );
}
